<template>
  <v-container fluid pt-0>
    <v-toolbar fixed color="blue darken-1">
      <v-toolbar-items class="hidden-sm-and-down">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="date"
              prepend-icon="event"
              readonly
              dark
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date" @input="menu = false"></v-date-picker>
        </v-menu>
        <v-btn
          color="blue darken-1"
          dark
          transition="fade-transition"
          @click.native="getDaily"
          ><v-icon style="padding-right: 12px">mdi-calendar-today</v-icon>
          Daily</v-btn
        >
        <v-btn
          color="blue darken-1"
          dark
          transition="fade-transition"
          @click.native="getHourly"
          ><v-icon style="padding-right: 12px">mdi-clock</v-icon>
          Hour-By-Hour</v-btn
        >
        <v-btn
          color="blue darken-1"
          dark
          transition="fade-transition"
          @click.native="getWeekly"
          ><v-icon style="padding-right: 12px">mdi-calendar-week</v-icon>
          Weekly</v-btn
        >
        <v-btn
          color="blue darken-1"
          dark
          transition="fade-transition"
          @click.native="getMonthly"
          ><v-icon style="padding-right: 12px">mdi-calendar-month</v-icon>
          Monthly</v-btn
        >
        <v-btn
          v-if="dlDaily"
          color="blue darken-1"
          dark
          @click.native="dailyExport"
          ><v-icon style="padding-right: 12px">cloud_download</v-icon> Download
          Report</v-btn
        >
        <v-btn
          v-if="dlOther"
          color="blue darken-1"
          dark
          @click.native="otherExport"
          ><v-icon style="padding-right: 12px">cloud_download</v-icon> Download
          Report</v-btn
        >
      </v-toolbar-items>
    </v-toolbar>
    <div class="Chart__list mb-4 table-margin">
      <div>
        <vue-good-table
          :columns="columns"
          :rows="rows"
          :max-height="this.height"
          :fixed-header="true"
        >
          <template
            slot="table-column"
            slot-scope="props"
            class="vgt-center-align"
          >
            <span
              v-if="props.column.field != 'id'"
              class="body-2 font-weight-bold"
            >
              {{ props.column.label }}
            </span>
            <span v-else>
              {{ props.column.label }}
            </span>
          </template>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.row.id == 'TOTAL'">
              <span style="font-weight: bold">{{
                props.formattedRow[props.column.field]
              }}</span>
            </span>
            <span v-else-if="props.row.date == 'TOTAL'">
              <span style="font-weight: bold">{{
                props.formattedRow[props.column.field]
              }}</span>
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
    <v-footer height="auto" class="tcc-orange-bg" fixed>
      <v-layout justify-center row wrap>
        <v-flex
          class="tcc-orange-bg"
          lighten-2
          py-3
          text-md-center
          white--text
          xs12
        >
          Last update: {{ updated }}
        </v-flex>
      </v-layout>
    </v-footer>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { VueGoodTable } from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import XLSX from "xlsx";

export default {
  name: "reports",

  components: {
    VueGoodTable,
  },

  data: () => ({
    date: new Date().toISOString().substr(0, 10),
    dlDaily: true,
    dlOther: false,
    menu: false,
    height: 0,
    loaded: false,
    updated: "",
    logs: [],
    labels: [],
    employees: [],
    columns: [],
    rows: [],
    printLogs: {},
    printRanks: {},
    totals: [],
  }),

  created() {
    this.loading = true;

    window.addEventListener("resize", this.handleResize);
    this.handleResize();

    this.getEmployees();
    this.getDaily();
  },

  methods: {
    rowsByDuration(logs) {
      const inboundLogs = logs.filter((log) => log.direction == "Inbound");
      const outboundLogs = logs.filter((log) => log.direction == "Outbound");
      const allNames = [...new Set(logs.map((log) => log.fromName))];

      const records = allNames.map((employeeName) => {
        // Calculate values
        let inboundCount = inboundLogs.filter(
          (log) => log.fromName == employeeName
        ).length;
        let inboundTotalSeconds = this.sumDurationForEmployee(
          inboundLogs,
          employeeName
        );
        let inboundTotalTime = this.toHHMMSS(inboundTotalSeconds);
        let inboundAverageSeconds =
          inboundCount != 0
            ? Math.floor(inboundTotalSeconds / inboundCount)
            : 0;
        let inboundAverageTime = this.toHHMMSS(inboundAverageSeconds);
        let outboundCount = outboundLogs.filter(
          (log) => log.fromName == employeeName
        ).length;
        let outboundTotalSeconds = this.sumDurationForEmployee(
          outboundLogs,
          employeeName
        );
        let outboundTotalTime = this.toHHMMSS(outboundTotalSeconds);
        let outboundAverageSeconds =
          outboundCount != 0
            ? Math.floor(outboundTotalSeconds / outboundCount)
            : 0;
        let outboundAverageTime = this.toHHMMSS(outboundAverageSeconds);

        // Create data structure
        return {
          id: employeeName,
          inboundCount: inboundCount,
          inboundTotalTime: inboundTotalTime,
          inboundAverageTime: inboundAverageTime,
          outboundCount: outboundCount,
          outboundTotalTime: outboundTotalTime,
          outboundAverageTime: outboundAverageTime,
        };
      });
      return records;
    },
    rowsByHourlyBreakdown(logs) {
      const allNames = [...new Set(logs.map((log) => log.fromName))];
      const records = allNames.map( employeeName => {
        const workingHours = this.getWorkingHours();
        const logsByHour = workingHours.map( hour => {
          let start = hour;
          let end = moment(hour).add(1, "hour").format("YYYY-MM-DD HH:MM:SS");
          let splicedLogs = logs.filter( log => {
            const pacificTime = moment(log.startTime).subtract(7, "hours");
            return moment(pacificTime).isBetween( moment(start), moment(end) );
          });
          let count = splicedLogs.filter(log => log.fromName == employeeName).length;
          return {
            "count": count,
            "hour": hour
          }
        });

        // Create data structure
        return {
          id: employeeName,
          6: logsByHour[0].count,
          7: logsByHour[1].count,
          8: logsByHour[2].count,
          9: logsByHour[3].count,
          10: logsByHour[4].count,
          11: logsByHour[5].count,
          12: logsByHour[6].count,
          13: logsByHour[7].count,
          14: logsByHour[8].count,
          total: 2,
        }
      });
      return records;
    },

    async getDaily() {
      this.setColumns("duration");
      this.dlDaily = true;
      this.dlOther = false;
      const startDate = `${this.date} 00:00:00`;
      const endDate = `${this.date} 23:59:59`;
      const dataEndpoint = `${process.env.API_ENDPOINT}/reports/'${startDate}'/'${endDate}'`;
      try {
        const response = await axios.get(dataEndpoint);
        const logs = response.data;
        console.log(logs)
        this.updated = moment().format("MMMM Do YYYY, h:mm a");
        this.rows = this.rowsByDuration(logs);
        this.loaded = true;
      } catch (err) {
        console.error(err);
      }
    },

    async getHourly() {
      this.setColumns("hourly");
      this.loaded = false;
      this.dlDaily = false;
      this.dlOther = true;
      let date = moment(this.date, "YYYY-MM-DD");
      const startDate = `${this.date} 00:00:00`;
      const endDate = `${this.date} 23:59:59`;
      const dataEndpoint = `${process.env.API_ENDPOINT}/reports/'${startDate}'/'${endDate}'`;
      try {
        const response = await axios.get(dataEndpoint);
        const logs = response.data;
        let records = this.rowsByHourlyBreakdown(logs);
        let rows = records;
        this.updated = moment().format("MMMM Do YYYY, h:mm a");
        this.rows = rows;
        this.loaded = true;
      } catch (err) {
        console.error(err);
      }
    },

    async getWeekly() {
      this.setColumns("duration");
      this.dlDaily = false;
      this.dlOther = true;
      let date = moment(this.date, "YYYY-MM-DD");
      const startDate = date.startOf("week").format("YYYY-MM-DD") + " 00:00:00";
      const endDate = date.endOf("week").format("YYYY-MM-DD") + " 23:59:59";
      const dataEndpoint = `${process.env.API_ENDPOINT}/reports/'${startDate}'/'${endDate}'`;
      try {
        const response = await axios.get(dataEndpoint);
        const logs = response.data;
        let records = this.rowsByDuration(logs);
        let rows = records;
        this.updated = moment().format("MMMM Do YYYY, h:mm a");
        this.rows = rows;
        this.loaded = true;
      } catch (err) {
        console.error(err);
      }
    },

    async getMonthly() {
      this.setColumns("duration");
      this.dlDaily = false;
      this.dlOther = true;
      let date = moment(this.date, "YYYY-MM-DD");
      const startDate = date.startOf("month").format("YYYY-MM-DD") + " 00:00:00";
      const endDate = date.endOf("month").format("YYYY-MM-DD") + " 23:59:59";
      const dataEndpoint = `${process.env.API_ENDPOINT}/reports/'${startDate}'/'${endDate}'`;
      try {
        const response = await axios.get(dataEndpoint);
        const logs = response.data;
        let records = this.rowsByDuration(logs);
        let rows = records;
        this.updated = moment().format("MMMM Do YYYY, h:mm a");
        this.rows = rows;
        this.loaded = true;
      } catch (err) {
        console.error(err);
      }
    },

    toHHMMSS(secs) {
      let days = 0;
      let secNum = parseInt(secs, 10);

      if (secNum) {
        days = Math.floor(secNum / 86400) * 24;
      }

      let hours = (Math.floor(secNum / 3600) % 24) + days;
      let minutes = Math.floor(secNum / 60) % 60;
      let seconds = secNum % 60;

      return [hours, minutes, seconds]
        .map((v) => (v < 10 ? "0" + v : v))
        .filter((v, i) => v !== "00" || i > 0)
        .join(":");
    },

    sumDurationForEmployee(logs, employeeName) {
      const logsInMinutes = logs
        .filter((log) => log.fromName == employeeName)
        .map((log) => log.duration)
        .reduce((total, next) => total + next, 0);
      return logsInMinutes;
    },

    getTotals(logs) {
      return logs.date === "TOTAL";
    },

    dailyExport() {
      this.printLogs = this.rows.map((a) => ({
        "Employee Name": a.id,
        "Inbound Count": a.inboundCount,
        "Inbound Total Time": a.inboundTotalTime,
        "Inbound Average Time": a.inboundAverageTime,
        "Outbound Count": a.outboundCount,
        "Outbound Total Time": a.outboundTotalTime,
        "Outbound Average Time": a.outboundAverageTime,
      }));

      let logsWS = XLSX.utils.json_to_sheet(this.printLogs);

      let wb = XLSX.utils.book_new();

      if (!wb.Props) {
        wb.Props = {};
      }
      wb.Props.Title = "Daily Detail Phone Log for " + this.date;

      XLSX.utils.book_append_sheet(wb, logsWS, "Daily Detail");
      XLSX.writeFile(wb, "Phone_Logs.xlsx");
    },

    otherExport() {
      this.printLogs = this.rows.map((a) => ({
        "Employee Name": a.id,
        Date: a.date,
        "Inbound Count": a.inboundCount,
        "Inbound Total Time": a.inboundTotalTime,
        "Inbound Average Time": a.inboundAverageTime,
        "Inbound Percent": a.inboundPercent,
        "Outbound Count": a.outboundCount,
        "Outbound Total Time": a.outboundTotalTime,
        "Outbound Average Time": a.outboundAverageTime,
        "Outbound Percent": a.outboundPercent,
      }));

      this.printRanks = this.totals.map((a) => ({
        "Employee Name": a.id,
        Inbound: a.inboundPercent,
        Outbound: a.outboundPercent,
        Total: a.totalPercent,
      }));

      let logsWS = XLSX.utils.json_to_sheet(this.printLogs);
      let ranksWS = XLSX.utils.json_to_sheet(this.printRanks);

      let wb = XLSX.utils.book_new();

      if (!wb.Props) {
        wb.Props = {};
      }
      wb.Props.Title = "Summary Phone Log for " + this.date;

      XLSX.utils.book_append_sheet(wb, logsWS, "Summary");
      XLSX.utils.book_append_sheet(wb, ranksWS, "Rankings");
      XLSX.writeFile(wb, "Phone_Logs.xlsx");
    },

    async getEmployees() {
      try {
        const response = await axios.get(`${process.env.API_ENDPOINT}/employees`);
        this.employees = response.data;
      } catch (e) {
        console.error(e);
      }
    },

    async getLogsByDate(startDate, endDate) {
      try {
        let dataEndpoint = `${process.env.API_ENDPOINT}/reports/${startDate}/${endDate}`;
        let response = await axios.get(dataEndpoint);
        return response.data;
      } catch (err) {
        console.error(err);
        return [];
      }
    },

    setColumns(context = "duration") {
      if (context == "hourly") {
        this.columns = [
          { field: "id" },
          {
            label: "6:00 AM",
            field: "6",
          },
          {
            label: "7:00 AM",
            field: "7",
          },
          {
            label: "8:00 AM",
            field: "8",
          },
          {
            label: "9:00 AM",
            field: "9",
          },
          {
            label: "10:00 AM",
            field: "10",
          },
          {
            label: "11:00 AM",
            field: "11",
          },
          {
            label: "12:00 PM",
            field: "12",
          },
          {
            label: "1:00 PM",
            field: "13",
          },
          {
            label: "2:00 PM",
            field: "14",
          },
          {
            label: "TOTAL",
            field: "total",
          },
        ];
      } else {
        this.columns = [
          {
            field: "id",
          },
          {
            label: "Inbound Count",
            field: "inboundCount",
          },
          {
            label: "Inbound Total Time",
            field: "inboundTotalTime",
          },
          {
            label: "Inbound Average Time",
            field: "inboundAverageTime",
          },
          {
            label: "Outbound Count",
            field: "outboundCount",
          },
          {
            label: "Outbound Total Time",
            field: "outboundTotalTime",
          },
          {
            label: "Outbound Average Time",
            field: "outboundAverageTime",
          },
        ];
      }
    },

    getWorkingHours() {
      return Array(9)
      .fill("")
      .map((item, idx) => {
        const hour = String(idx + 6);
        const hh = hour.padStart(2, "0");
        return `${this.date} ${hh}:00:00`;
      });
    },

    tdClassFunc(row) {
      return "vgt-center";
    },

    handleResize() {
      const height = window.innerHeight - 160;
      this.height = height + "px";
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.table-margin {
  margin-top: 80px;
}

.vgt-fixed-header {
  z-index: 1;
}

.vgt-fixed-header th:last-child {
  /* Offset for the scrollbar, you may have to adjust this */
  width: calc(100% + 17px) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Reports.vue